import useDrawerContext from '@contexts/drawerContext'
import { Drawer } from '@mui/material'

const drawerSlotProps = () => ({
  backdrop: {
    style: {
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
  },
  paper: {
    style: {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  },
  modal: {
    keepMounted: false,
  }
})

const RightDrawer = () => {
  const { rightDrawerContents, closeRightDrawer, isRightDrawerOpen } = useDrawerContext()
  const isContentFunctional = typeof rightDrawerContents.current === 'function'

  return (
    <Drawer
      anchor='right'
      slotProps={drawerSlotProps()}
      open={isRightDrawerOpen}
      onClose={closeRightDrawer}>
      <div style={{ position: 'relative' }}>
        {isContentFunctional
          ? rightDrawerContents.current()
          : rightDrawerContents.current
        }
      </div>
    </Drawer>
  )
}

export default RightDrawer
